module.exports = __webpack_public_path__ + "ee46ad87773747da14a09837b3a147cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bell.png
// module id = 2006
// module chunks = 0